<script>
import { ref } from 'vue';
import useHelpList from '@/constants/usehelp';
import useNavigate from '@/hooks/useNavigate';
export default {
	name: 'Howtouse',
	setup() {
		const activeName = ref('');
		const { goBack } = useNavigate();

		return () => {
			return (
				<>
					<nut-navbar
						fixed
						placeholder={false}
						leftShow
						class="navbar"
						title="客户端使用问答"
						onOnClickBack={goBack}
					></nut-navbar>
					<div className="main">
						<nut-collapse
							v-model:active={activeName.value}
							accordion
						>
							{useHelpList.map((item) => {
								return (
									<nut-collapse-item
										key={item.title}
										title={item.title}
										name={item.title}
									>
										{item.list.map((listItem, index) => {
											return (
												<p class="item" key={index}>
													{listItem}
												</p>
											);
										})}
									</nut-collapse-item>
								);
							})}
						</nut-collapse>
					</div>
				</>
			);
		};
	},
};
</script>

<style lang="scss" scoped>
.main {
	margin-top: $navbar-height;

	.item {
		:deep(.link) {
			color: $primary-color;
		}
	}

	:deep(.collapse-icon-title) {
		font-weight: 600;
		color: #333;
	}
}
</style>
